// The composer's two steps, in order: pick the group, then fill the post.
export const STEPS = {
    GROUP: "group",
    POST: "post",
};
